import React from 'react';
import { Link } from 'react-router-dom';
import profileImg from '../../assets/yogesh-singh-frontend-developer.png';

import {
  FaWhatsapp,
  FaLinkedin,
  FaGithub,
  FaInstagram,
  FaTwitter,
} from 'react-icons/fa';
import CV from '../../assets/resume_4yrs.pdf';

const Home = () => {
  return (
    <section id="home" className="relative overflow-hidden bg-[#0b0f17]">
      <div className="max-w-7xl mx-auto px-6 pt-16 md:pt-20 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-12">
          {/* LEFT */}
          <div className="max-w-xl space-y-6">
            <p className="text-xs tracking-[0.22em] uppercase text-accent/80">
              Gurgaon, India · Frontend engineering
            </p>

            <div className="space-y-3">
              <h1 className="text-5xl md:text-6xl font-bold text-white tracking-tight">
                Yogesh Singh
              </h1>
              <p className="text-lg text-gray-300">
                Frontend developer · React &amp; Next.js
              </p>
            </div>

            <p className="text-gray-400 leading-relaxed">
              I ship fast, accessible interfaces for products people use every day—dashboards,
              marketplaces, and real-time web apps.
            </p>

            <div className="flex flex-wrap gap-2">
              {['React', 'Next.js', 'TypeScript', 'JavaScript', 'Tailwind', 'Redux'].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 rounded-full text-xs font-medium text-gray-200 border border-white/10 bg-white/5"
                >
                  {t}
                </span>
              ))}
            </div>

            <p className="text-gray-400 leading-relaxed">
              4+ years building scalable UIs: healthcare platforms, EdTech, e-commerce, and internal
              tools—focused on performance, clarity, and maintainable code.
            </p>

            <div className="flex flex-wrap gap-3 pt-2">
              <a
                href="#work"
                className="h-11 inline-flex items-center justify-center rounded-lg bg-accent px-5 text-sm font-semibold text-black shadow-soft transition-transform hover:scale-[1.02]"
              >
                View Projects
              </a>
              <a
                download="Yogesh_Singh_Resume.pdf"
                href={CV}
                className="h-11 inline-flex items-center justify-center rounded-lg border border-white/15 bg-white/5 px-5 text-sm font-semibold text-white/90 transition-transform hover:scale-[1.02] hover:bg-white/10"
              >
                Resume
              </a>
              <Link
                to="/yogesh-singh"
                className="h-11 inline-flex items-center justify-center rounded-lg px-5 text-sm font-semibold text-white/80 hover:text-white transition-colors"
              >
                Full profile
              </Link>
            </div>

            <div className="flex items-center gap-4 pt-2 text-white/70">
              <a href="https://wa.link/br0lsr" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="hover:text-white transition-colors">
                <FaWhatsapp />
              </a>
              <a href="https://www.linkedin.com/in/yogesh1dev" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-white transition-colors">
                <FaLinkedin />
              </a>
              <a href="https://github.com/yogeshmlv" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="hover:text-white transition-colors">
                <FaGithub />
              </a>
              <a href="https://www.instagram.com/its__novo/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors">
                <FaInstagram />
              </a>
              <a href="https://twitter.com/Yogesh__Dev" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-white transition-colors">
                <FaTwitter />
              </a>
            </div>
          </div>
          
          {/* RIGHT */}
          <div className="relative flex justify-center md:justify-end">
            {/* glow */}
            <div className="absolute -inset-6 md:-inset-10 bg-gradient-to-tr from-accent/25 via-emerald-500/10 to-transparent blur-3xl rounded-full" />

            <div className="relative w-[320px] sm:w-[380px] md:w-[440px] aspect-square">
              {/* gradient circle */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-accent/35 via-emerald-600/20 to-transparent border border-white/10 shadow-soft" />

              <img
                src={profileImg}
                alt="Yogesh Singh, Frontend Developer and React developer based in Gurgaon, India"
                className="absolute inset-0 w-full h-full object-cover rounded-full p-6"
                width={520}
                height={520}
                decoding="async"
                fetchpriority="high"
              />

              {/* Floating cards */}
              <div className="absolute left-3 bottom-10 sm:left-6 sm:bottom-12 rounded-2xl border border-white/10 bg-black/40 backdrop-blur px-4 py-3 shadow-soft">
                <div className="flex items-baseline gap-2">
                  <span className="text-2xl font-bold text-white">4+</span>
                  <span className="text-[11px] tracking-[0.2em] uppercase text-white/70">Years</span>
                </div>
                <p className="text-[11px] text-white/70">Experience</p>
              </div>

              <div className="absolute right-3 bottom-4 sm:right-6 sm:bottom-6 rounded-2xl border border-white/10 bg-black/40 backdrop-blur px-4 py-3 shadow-soft">
                <div className="flex items-baseline gap-2">
                  <span className="text-2xl font-bold text-white">15+</span>
                  <span className="text-[11px] tracking-[0.2em] uppercase text-white/70">Prod.</span>
                </div>
                <p className="text-[11px] text-white/70">Projects</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
